import AuthStore from './AuthStore';
import BallotStore from './BallotStore/BallotStore';
import CandidateStore from './CandidateStore/CandidateStore';
import FreetextStore from './FreetextStore/freetextStore';
import PreviewStore from './PreviewStore';
import VoteStore from './VoteStore/VoteStore';

export default class AppStore {
    ballotStore = new BallotStore();
    candidateStore = new CandidateStore();
    authStore = new AuthStore();
    previewStore = new PreviewStore();
    voteStore = new VoteStore();
    freetextStore = new FreetextStore();

    resetAllStoreData = () => {
        this.ballotStore.resetToDefault();
        this.candidateStore.resetToDefault();
        this.authStore.resetToDefault();
        this.previewStore.resetToDefault();
        this.voteStore.resetToDefault();
        this.freetextStore.resetToDefault();
    };
}

let store: AppStore;

function initializeStore() {
    const _store = new AppStore();

    store = _store;

    return store;
}

// This getStore can be mocked in unit test expected to test with store easier
function getStore() {
    if (!store) {
        initializeStore();
    }
    return store;
}

export { getStore };
